module.exports = __webpack_public_path__ + "media/img/event/profiling-result-mobile-758340112eb866b785e7cc3d4658cc06.png";